export default __webpack_public_path__ + "static/media/selectIcon.fcb1d707.png";